const lis = document.querySelectorAll('ul.mobile-menu-list li.menu-item-has-children');
for (const li of lis) {
  const a = li.querySelector('a');
  const submenu = li.querySelector('ul');
  if (a) {
    const span = document.createElement('span');
    span.innerText = '+';
    span.classList.add('show-sub-items');
    a.insertAdjacentElement('afterend', span);

    let isActive = false;
    span.addEventListener('click', () => {
      submenu.classList.toggle('sub-menu--active');

      if (!isActive) {
        span.textContent = '-';
      } else {
        span.textContent = '+';
      }
      isActive = !isActive;
    });
  }
}
